import { NotificationItemBaseProps } from "../../types/notification.types";
import { NotificationTranslatedStringsItem } from "./NotificationTranslatedStringsItem";
import { NotificationTranslatedStrings } from "./types/translated-strings.types";

interface NotificationTranslatedStringFactoryProps {
  content: unknown;
  extraProps: NotificationItemBaseProps;
}
export const NotificationTranslatedStringFactory = ({
  content,
  extraProps,
}: NotificationTranslatedStringFactoryProps) => {
  const translatedStringContent = content as NotificationTranslatedStrings;
  const { props } = translatedStringContent;

  return <NotificationTranslatedStringsItem {...extraProps} {...props} />;
};
